// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1j4ff","tab":"ProcedureTabs_tab__3BiQw"};